export { DashboardAbsencesItem } from "./dashboard-absences-item";
